/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type PlaceholderType = typeof PlaceholderType[keyof typeof PlaceholderType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlaceholderType = {
  Accommodation: 'Accommodation',
  Transport: 'Transport',
  Activities: 'Activities',
  LocalGuides: 'LocalGuides',
  OtherServices: 'OtherServices',
} as const;
